import { Component, Input } from '@angular/core';
import { DateUtil } from '../../../ui/DateUtil';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-diff-viewer',
  templateUrl: './diff-viewer.component.html',
  styleUrl: './diff-viewer.component.scss'
})
export class DiffViewerComponent {
  @Input() diffs!: any;

    constructor(public bsModalRef: BsModalRef) { }

  public getDateFormat(date: any) {
    return DateUtil.getDateTimeFormat(date);
  }

  public calculateRowspan(diffs: any[]): number {
    return diffs ? diffs.length : 0;
  }

  onCheckboxChange(item:any, isChecked: boolean): void {
    item.isChecked = isChecked;
  }

}
